<script lang="ts">
    import { PinInput as InputOTPPrimitive } from "bits-ui";
    import { cn } from "../../../utils.js";

    let { ref = $bindable(null), cell, class: className, ...restProps }: InputOTPPrimitive.CellProps = $props();
</script>

<InputOTPPrimitive.Cell
    {cell}
    bind:ref
    data-slot="input-otp-slot"
    class={cn(
        "border-input aria-invalid:border-destructive dark:bg-input/30 relative flex size-9 items-center justify-center border-y border-r text-sm transition-all outline-none first:rounded-l-md first:border-l last:rounded-r-md",
        cell.isActive &&
            "border-ring ring-ring/50 aria-invalid:border-destructive dark:aria-invalid:ring-destructive/40 aria-invalid:ring-destructive/20 ring-offset-background z-10 ring-[3px]",
        className,
    )}
    {...restProps}
>
    {cell.char}
    {#if cell.hasFakeCaret}
        <div class="pointer-events-none absolute inset-0 flex items-center justify-center">
            <div class="animate-caret-blink bg-foreground h-4 w-px duration-1000"></div>
        </div>
    {/if}
</InputOTPPrimitive.Cell>
